import { render, staticRenderFns } from "./FederalExcise.vue?vue&type=template&id=32e09210"
import script from "./FederalExcise.vue?vue&type=script&lang=js"
export * from "./FederalExcise.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports